import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { PopupButtonPrimitive } from '../../popup-button-primitive/popup-button-primitive.js';
import { icon, baseIconButton } from '../base-icon-button.module.css.js';
import * as dialogTriggerButton_module from './dialog-trigger-button.module.css.js';
import { dialogTriggerButton, lg } from './dialog-trigger-button.module.css.js';

const SIZE_STYLES = {
    md: undefined,
    lg: lg,
};
/**
 * When an icon has a toggle-able state that opens and closes a draggable window or a popover of some kind like a dropdown, we use a dialog trigger button.
 *
 * @see https://fpl.figma.design/components/buttons/dialog-trigger-button/
 */
const DialogTriggerButton = forwardRef(({ children, size = 'md', variant = 'ghost', ...props }, ref) => {
    return (jsx(PopupButtonPrimitive, { "data-fpl-component": "", ...props, ref: ref, "data-tooltip": props?.['data-tooltip'] ?? props['aria-label'], "data-tooltip-type": props?.['data-tooltip-type'] ?? 'text', "aria-haspopup": 'aria-haspopup' in props ? props['aria-haspopup'] : 'dialog', className: clsx(baseIconButton, dialogTriggerButton, dialogTriggerButton_module[variant], SIZE_STYLES[size]), children: jsx("span", { className: icon, "aria-hidden": true, children: children }) }));
});
DialogTriggerButton.displayName = 'DialogTriggerButton';

export { DialogTriggerButton };
//# sourceMappingURL=dialog-trigger-button.js.map
